import {
  Box,
  Container,
  Grid,
  Typography,
  IconButton,
  Link,
} from "@mui/material";

import {
  Facebook,
  Twitter,
  Instagram,
  LocationOn,
  Phone,
  Email,
} from "@mui/icons-material";
import logo from "../assets/logo.png";
import { motion } from "framer-motion";
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
const Footer = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.3 }}
      transition={{ duration: 0.7, ease: "easeOut" }}
    >
      <Box
        component="footer"
        sx={{
          position: "relative",
          color: "#fff",
          backgroundImage:
            "url(https://rstheme.com/products/wordpress/konstruk/wp-content/uploads/2022/03/footer-bg.jpg)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        {/* Dark overlay */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            backgroundColor: "#0000007d)",
          }}
        />

        <Container sx={{ position: "relative", py: 10 }}>
          <Grid container spacing={4}>
            {/* COLUMN 1 */}
            <Grid item size={{ xs: 12, md: 4 }}>
              <Box
                component="img"
                src={logo}
                alt="KONSTRUK logo"
                sx={{
                  // height: 40,
                  width: "auto",
                  marginLeft: "-25px",
                }}
              />

              <Typography
                variant="body2"
                sx={{
                  mb: 3,
                  fontWeight: "500",
                  wordSpacing: "1px",
                  letterSpacing: "0.8px",
                }}
              >
                SHANKH TRADE !! Supplying Strength for Roads & Structures.
                Materials That Carry the Nation Forward, The Foundation Behind
                Every Build.
              </Typography>

              <Box>
                <IconButton sx={{ color: "#fff" }}>
                  <Facebook />
                </IconButton>
                <IconButton sx={{ color: "#fff" }}>
                  <Twitter />
                </IconButton>
                <IconButton 
                    component="a"
                    href="https://www.instagram.com/shankh_trading_official/"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ color: "#fff" }}
                  >
                    <Instagram />
                  </IconButton>
              </Box>
            </Grid>

            {/* COLUMN 2 */}
            <Grid item size={{ xs: 12, md: 3 }}>
              <Typography variant="h6" fontWeight={700} gutterBottom>
                CONTACT INFO
              </Typography>

              <Box sx={{ display: "flex", mb: 3, alignItems: "center" }}>
                <LocationOn sx={{ color: "var(--primary-yellow)", mr: 1 }} />
                <Typography variant="body2">
                  1/8, Vardan Khand, Sector 1, Gomti Nagar, Lucknow, Uttar
                  Pradesh
                </Typography>
              </Box>

              <Box sx={{ display: "flex", mb: 3, alignItems: "center" }}>
                <Phone sx={{ color: "var(--primary-yellow)", mr: 1 }} />
                <Typography variant="body2">
                  (+91) 993570193
                  <br />
                  (+91) 6390902009
                </Typography>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Email sx={{ color: "var(--primary-yellow)", mr: 1 }} />
                <Typography variant="body2">
                  <a
                    href="mailto:hr@shankhtrading.com"
                    style={{ color: "inherit", textDecoration: "none" }}
                  >
                    hr@shankhtrading.com
                  </a>
                </Typography>
              </Box>
            </Grid>

            {/* COLUMN 3 */}
            <Grid item size={{ xs: 12, md: 2 }}>
              <Typography variant="h6" fontWeight={700} gutterBottom>
                OUR SERVICES
              </Typography>

              {[
                "General Construction",
                "Property Maintenance",
                "Sand & Stones Supply",
                "Project Management",
                "Virtual Design & Build",
              ].map((service) => (
                <Typography
                  key={service}
                  variant="body2"
                  sx={{ mb: 2, cursor: "pointer" }}
                >
                  › {service}
                </Typography>
              ))}
            </Grid>

            {/* COLUMN 4 */}
            <Grid item size={{ xs: 12, md: 3 }}>
              <Typography variant="h6" fontWeight={700} gutterBottom>
                CAREERS
              </Typography>

              <Typography variant="body1" sx={{ mb: 1, opacity: 0.9 }}>
                Build your career with us. <br />
              </Typography>
              <Typography variant="body2" color="#9b9b9b" sx={{ mb: 3 }}>
                If you are hardworking, disciplined, and committed to
                excellence, there is a place for you here.
              </Typography>

              <Link href="/" className="careerBtn" underline="none" color="#fff">
                  View Openings  <ArrowForwardOutlinedIcon sx={{ ml: 0.5,  transition: "all 0.3s ease-in-out" }} />
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </motion.div>
  );
};

export default Footer;
